import DynamicSegmentedButton from '@/components/DynamicSegmentedButton';
import useToggleExpandCalendar, { DailyPlanView, DailyPlanViewType } from '@/stores/useToggleExpandCalendar';
import { getLocale } from '@/utils/calendar';
import rem from '@/utils/rem';
import { HStack, StackProps, Text, VStack } from '@chakra-ui/react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

type DayToolbarProps = {
  date: Date;
} & StackProps;

export default function DayToolbar(props: DayToolbarProps) {
  const { t, i18n } = useTranslation('DailyPlan');
  const locale = getLocale(i18n.language);
  const { dailyPlanView, setDailyPlanView } = useToggleExpandCalendar();

  return (
    <VStack alignItems="flex-start" gap={rem(20)} {...props}>
      <HStack alignItems="center" justifyContent="space-between" gap={rem(8)} width="full">
        <Text textStyle="small">
          <span
            style={{
              fontWeight: 900,
            }}
          >
            {format(props.date, 'EEEE', { locale })}
          </span>{' '}
          {format(props.date, 'MMMM dd', { locale })}
        </Text>
        <DynamicSegmentedButton
          onChange={(value: number) => setDailyPlanView(value as DailyPlanViewType)}
          options={[
            {
              value: DailyPlanView.Condense,
              label: t('segmentedButtons.condense'),
            },
            {
              value: DailyPlanView.Expand,
              label: t('segmentedButtons.expand'),
            },
          ]}
          layoutId="daily-plan-schedule-options"
          startIndex={dailyPlanView}
        />
      </HStack>
    </VStack>
  );
}
